const system =
{
  // 基础后台接口链接
  baseApiUrl: 'http://120.211.237.143:8090/serverApi',
  // 基础后台上传文件接口链接
  baseUploadApiUrl: 'http://120.211.237.143:8090/serverApi/Api/SystemModule/SystemFile/UploadFile',
  // 基础后台上传大文件接口链接
  baseBigUploadApiUrl: 'http://120.211.237.143:8090/serverApi/Api/SystemModule/SystemFile/UploadBigFile',
  // 基础PDF文件接口
  basePDFShowUrl: 'http://120.211.237.143:8090/serverApi/PDFShow/show.html?file=',

  ggycmxUrl: 'http://120.211.237.143:8090/predictionModelSystem/indexAdminLogin', //灌溉预测模型
  zhhzzUrl: 'http://120.211.237.143:8090/intelligentPlantSystem/indexAdminLogin', //智慧化种植
  yjxtUrl: 'http://120.211.237.143:8090/earlyWarnSystem/indexAdminLogin', //预警系统
  sjbbUrl: 'http://120.211.237.143:8090/dataReportModelSystem/indexAdminLogin', //数据报表
  wlwsjjcjfxUrl: 'http://120.211.237.143:8090/lotDataInterationSystem/indexAdminLogin', //物联网数据集成及分析
  zyggkzUrl: 'https://www.farm-iot.cn/Account/LoginExt?sign=F10zPdpl4WmSghV55zbRffLa5KZEfE5d', //中央灌溉控制
  yhglUrl: 'http://120.211.237.143:8090/userManageSystem/indexAdminLogin', //用户管理
  jcszUrl: 'http://120.211.237.143:8090/baseSetSystem/indexAdminLogin', //基础设置
  xtszUrl: 'http://120.211.237.143:8090/systemSetSystem/indexAdminLogin', // 系统设置
}

export default system
